import { render, staticRenderFns } from "./Trimming.vue?vue&type=template&id=231d7c5a&scoped=true&"
import script from "./Trimming.vue?vue&type=script&lang=js&"
export * from "./Trimming.vue?vue&type=script&lang=js&"
import style0 from "./Trimming.vue?vue&type=style&index=0&id=231d7c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231d7c5a",
  null
  
)

export default component.exports